export enum PipelineRequestStatusEnum {
    PendingAmReview = 1,
    Pipelined = 2,
    Cancelled = 3,
    Archived = 4,
    PendingContractReview = 5,
    UpdatePendingAMReview = 6
}
